<template>
  <div>
    <!-- 复审 -->
    <el-dialog :close-on-click-modal="false" :title="$t('message.reReview')" :visible.sync="dialogVisible" width="780px"
      center>
      <div class="content">

        <!-- *类型 -->
        <div class="row">
          <div class="label" style="line-height: 40px;">
            <span>*</span> {{ $t('message.type') }} :
          </div>
          <div class="val" style="line-height: 40px;">
            <el-radio v-model="datas.is_complain" :label="1">确认投诉</el-radio>
            <el-radio v-model="datas.is_complain" :label="0" @change="handleChange">非投诉</el-radio>
          </div>
        </div>
        <!-- *投诉类别： -->
        <div class="row">
          <div class="label" style="line-height: 40px;">
            <span>*</span> {{ $t('message.complaintType') }} :
          </div>
          <div class="val">
            <el-select v-model="datas.complaint_type" :placeholder="$t('message.complaintType')" filterable>
              <el-option v-for="item in $parent.complaintType" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 日本审核备注 -->
        <div class="row">
          <div class="label">
            <span>*</span> {{ $t('message.japanReviewRemarks') }} :
          </div>
          <div class="val">
            <el-input type="textarea" v-model="datas.review_remark"></el-input>
          </div>
        </div>
        <!-- *是否纳入考核 -->
        <div class="row">
          <div class="label" style="line-height: 40px;">
            <span>*</span> {{ $t('message.isIncludedInAssessment') }} :
          </div>
          <div class="val" style="line-height: 40px;">
            <!-- 是 -->
            <el-radio v-model="datas.performance_status" :label="1">{{ $t('message.are') }}</el-radio>
            <!-- 否 -->
            <el-radio v-model="datas.performance_status" :label="2">{{ $t('message.no') }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      datas: {
        id: '',
        type: '',
        review_remark: '',
        is_complain: '',
      },
    };
  },
  methods: {
    // 投诉类别改变时，判断是否是投诉
    handleChange() {
      if (this.datas.is_complain == 0) {
        this.datas.performance_status = 2
      }
    },
    // 保存
    save() {
      this.$confirm('请谨慎确认，是否审核完成，审核完成后将无法进行变更。', '提醒', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.siteConfiguration.japanReviewV4(this.datas).then(res => {
          this.$message.success(res.msg)
          this.dialogVisible = false
          this.$parent.clientListV4()
        })
      }).catch(() => {

      });

    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 118px;
      margin-right: 20px;
      width: 120px;

      span {
        color: red;
      }
    }

    .val {
      flex: 3;

      p {
        margin-top: 20px;
      }
    }
  }


}
</style>
